import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 检测是否在预渲染环境中
const isPrerender = navigator.userAgent.includes('HeadlessChrome') || 
                    window.__PRERENDER_INJECTED || 
                    window.location.href.includes('prerender');

// SEO 动态更新工具函数
const updateSEO = (to) => {
  // 获取路由元数据
  const meta = to.meta || {};
  
  // 更新页面标题
  if (meta.title) {
    document.title = meta.title;
  }
  
  // 更新 meta description
  let descMeta = document.querySelector('meta[name="description"]');
  if (!descMeta) {
    descMeta = document.createElement('meta');
    descMeta.name = 'description';
    document.head.appendChild(descMeta);
  }
  if (meta.description) {
    descMeta.content = meta.description;
  }
  
  // 更新 meta keywords
  let keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (!keywordsMeta) {
    keywordsMeta = document.createElement('meta');
    keywordsMeta.name = 'keywords';
    document.head.appendChild(keywordsMeta);
  }
  if (meta.keywords) {
    keywordsMeta.content = meta.keywords;
  }
  
  // 更新 canonical 链接
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.href = window.location.origin + to.path;
};

// 路由守卫 - 页面切换时更新 SEO
router.beforeEach((to, from, next) => {
  updateSEO(to);
  next();
});

// 首次加载时更新 SEO
router.onReady(() => {
  updateSEO(router.currentRoute);
});

// 在预渲染时挂载到 #app，正常模式下也挂载到 #app
// 预渲染插件会捕获挂载后的 HTML
const app = new Vue({
  router,
  render: h => h(App),
  mounted() {
    // 预渲染完成后触发事件，通知渲染器页面已准备好
    // 使用 $nextTick 确保 DOM 完全更新
    this.$nextTick(() => {
      if (isPrerender || window.__PRERENDER_INJECTED) {
        console.log('Prerender: Document render event dispatched');
        document.dispatchEvent(new Event('render-event'));
      }
    });
  }
});

// 等待路由准备好后再挂载
router.onReady(() => {
  app.$mount('#app');
});